import { bindPage } from '../modules/page_lifecycle.js';
import { hideElement, showElement } from '../modules/dom.js';

function resolveActiveSubmenuName() {
  const activeSubmenuLink = document.querySelector('.sub-menu a.active');
  if (activeSubmenuLink) {
    return activeSubmenuLink.closest('.sub-menu')?.dataset.subMenuName;
  }

  const activeMenuLink = document.querySelector('.main-menu a.active');
  if (activeMenuLink) return activeMenuLink.dataset.menuName;

  return document.querySelector('.sub-menu')?.dataset.subMenuName;
}

function hideAllSubmenusExcept(name) {
  document.querySelectorAll('.sub-menu').forEach((menu) => hideElement(menu));
  if (!name) return;

  document.querySelectorAll(`.sub-menu[data-sub-menu-name="${name}"]`).forEach((menu) => showElement(menu));
}

bindPage(() => {
  const activeSubmenuName = resolveActiveSubmenuName();
  const topMenu = document.querySelector('.top-menu');
  if (!topMenu) return;

  const onMouseEnter = (event) => hideAllSubmenusExcept(event.currentTarget.dataset.menuName);
  const onMouseLeave = () => hideAllSubmenusExcept(activeSubmenuName);

  topMenu.querySelectorAll('.main-menu a').forEach((link) => {
    link.addEventListener('mouseenter', onMouseEnter);
  });
  topMenu.addEventListener('mouseleave', onMouseLeave);

  if (activeSubmenuName) {
    hideAllSubmenusExcept(activeSubmenuName);
  } else {
    const firstActive = document.querySelector('.main-menu a.active');
    hideAllSubmenusExcept(firstActive?.dataset.menuName);
  }

  return () => {
    topMenu.querySelectorAll('.main-menu a').forEach((link) => {
      link.removeEventListener('mouseenter', onMouseEnter);
    });
    topMenu.removeEventListener('mouseleave', onMouseLeave);
  };
});
